



























































import {
  defineComponent,
  PropType,
  ref,
  computed,
  onMounted,
  useRoute,
} from "@nuxtjs/composition-api";
import { useLoyalty } from "~/modules/customer/composables/useLoyalty";
import SkeletonLoader from "~/components/SkeletonLoader/index.vue";
import Pagination from "~/components/Pagination/Pagination.vue";

export default defineComponent({
  name: "LoyaltyHistoryList",
  props: {
    loyaltyName: {
      type: String as PropType<string>,
      required: false,
    },
  },
  components: {
    SkeletonLoader,
    Pagination,
  },
  setup(props) {
    const isPointsActive = ref(false);
    const route = useRoute();
    const routeParams = ref<Record<string, string>>({});
    const hasActiveParam = computed(() => routeParams.value.isActive === 'true');
    
    const togglePoints = () => {
      isPointsActive.value = !isPointsActive.value;
      
      if (routeParams.value) {
        if (isPointsActive.value) {
          routeParams.value.isActive = 'true';
        } else {
          routeParams.value.isActive = 'false';
        }
      }
    };

    onMounted(() => {
      routeParams.value = route.value.params || {};
      if (hasActiveParam.value) {
        isPointsActive.value = true;
      }
    });

    const { loyaltyHistory, loading, load } = useLoyalty();
    const currentPage = ref(1);
    const pageSize = 8;

    const historyData = computed(() => {
      return loyaltyHistory.value?.result?.data || [];
    });

    const totalItems = computed(() => {
      return loyaltyHistory.value?.result?.total || 0;
    });
    
    const totalPages = computed(() => {
      if (!loyaltyHistory.value) return 1;
      return Math.ceil(loyaltyHistory.value.result.total / pageSize);
    });

    const loadLoyaltyHistory = async () => {
      await load({
        loyalty_card: props.loyaltyName,
        limit: pageSize,
        offset: (currentPage.value - 1) * pageSize,
      });
    };

    const handlePageChange = (page: number) => {
      currentPage.value = page;
      loadLoyaltyHistory();
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
        loadLoyaltyHistory();
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
        loadLoyaltyHistory();
      }
    };

    const goToPage = (page: number) => {
      currentPage.value = page;
      loadLoyaltyHistory();
    };

    const getOrderSource = (orderReference: string): string => {
      return orderReference.startsWith('CNF') ? 'Online' : 'Cửa hàng';
    };

    onMounted(() => {
      loadLoyaltyHistory();
    });

    return {
      loading,
      historyData,
      currentPage,
      totalPages,
      totalItems,
      pageSize,
      handlePageChange,
      prevPage,
      nextPage,
      goToPage,
      loyaltyHistory,
      getOrderSource,
      togglePoints,
      isPointsActive,
      routeParams,
      hasActiveParam
    };
  },
});
